$(document).ready(function() {
  var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
  var param;  
  if (metafield.trim() !== "") {param = metafield;} 
  else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
    $.getJSON('https://financialmodelingprep.com/api/v3/ratios-ttm/'+param+'?apikey=3ccf620ce9315de8a4996e601373f716', function(data){
      $.each(data, function(i, elem){
          
/*Valuation Ratios*/
        
         if (elem.peRatioTTM == null) {var peRatioTTM_var = 'n/a';} else
         {var peRatioTTM_var = nFormatter(elem.peRatioTTM, 2);}
         $('#stat_pe_ratio').append(peRatioTTM_var);
         $('#stat_pe_ratio2').append(peRatioTTM_var);

         if (elem.priceToSalesRatioTTM == null) {var priceToSalesRatioTTM_var = 'n/a';} else
         {var priceToSalesRatioTTM_var = nFormatter(elem.priceToSalesRatioTTM, 2);}
         $('#stat_ps_ratio').append(priceToSalesRatioTTM_var);

         if (elem.priceToBookRatioTTM == null) {var priceToBookRatioTTM_var = 'n/a';} else
         {var priceToBookRatioTTM_var = nFormatter(elem.priceToBookRatioTTM, 2);}
         $('#stat_pb_ratio').append(priceToBookRatioTTM_var);

         if (elem.priceToFreeCashFlowsRatioTTM == null) {var priceToFreeCashFlowsRatioTTM_var = 'n/a';} else
         {var priceToFreeCashFlowsRatioTTM_var = nFormatter(elem.priceToFreeCashFlowsRatioTTM, 2);}
         $('#stat_p_fcf_ratio').append(priceToFreeCashFlowsRatioTTM_var);

         if (elem.pegRatioTTM == null) {var pegRatioTTM_var = 'n/a';} else
         {var pegRatioTTM_var = nFormatter(elem.pegRatioTTM, 2);}
         $('#stat_peg_ratio').append(pegRatioTTM_var); 
         $('#stat_peg_ratio2').append(pegRatioTTM_var);

/*Financial Position*/
        
         if (elem.currentRatioTTM == null) {var currentRatioTTM_var = 'n/a';} else
         {var currentRatioTTM_var = nFormatter(elem.currentRatioTTM, 2);}
         $('#stat_current_ratio').append(currentRatioTTM_var);
         $('#stat_current_ratio2').append(currentRatioTTM_var);        

         if (elem.quickRatioTTM == null) {var quickRatioTTM_var = 'n/a';} else
         {var quickRatioTTM_var = nFormatter(elem.quickRatioTTM, 2);}
         $('#stat_quick_ratio').append(quickRatioTTM_var);        

         if (elem.ebtPerEbitTTM == null) {var ebtPerEbitTTM_var = 'n/a';} else
         {var ebtPerEbitTTM_var = nFormatter(elem.ebtPerEbitTTM, 2);}
         $('#stat_debt_ebit').append(ebtPerEbitTTM_var);        
        
/*Financial Efficiency*/

         if (elem.returnOnEquityTTM == null) {var returnOnEquityTTM_var = 'n/a';} else
         {var returnOnEquityTTM_var = elem.returnOnEquityTTM.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#stat_return_on_equity_roe').append(returnOnEquityTTM_var);
         $('#stat_return_on_equity_roe2').append(returnOnEquityTTM_var);
        

         if (elem.returnOnAssetsTTM == null) {var returnOnAssetsTTM_var = 'n/a';} else
         {var returnOnAssetsTTM_var = elem.returnOnAssetsTTM.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#stat_return_on_assets_roa').append(returnOnAssetsTTM_var);        

/*Margins*/

         if (elem.grossProfitMarginTTM == null) {var grossProfitMarginTTM_var = 'n/a';} else
         {var grossProfitMarginTTM_var = elem.grossProfitMarginTTM.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#stat_gross_margin').append(grossProfitMarginTTM_var);
         $('#stat_gross_margin2').append(grossProfitMarginTTM_var);        
        
         if (elem.operatingProfitMarginTTM == null) {var operatingProfitMarginTTM_var = 'n/a';} else
         {var operatingProfitMarginTTM_var = elem.operatingProfitMarginTTM.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#stat_operating_margin').append(operatingProfitMarginTTM_var);        
         $('#stat_operating_margin2').append(operatingProfitMarginTTM_var);                

         if (elem.pretaxProfitMarginTTM == null) {var pretaxProfitMarginTTM_var = 'n/a';} else
         {var pretaxProfitMarginTTM_var = elem.pretaxProfitMarginTTM.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#stat_pretax_margin').append(pretaxProfitMarginTTM_var);        

         if (elem.netProfitMarginTTM == null) {var netProfitMarginTTM_var = 'n/a';} else
         {var netProfitMarginTTM_var = elem.netProfitMarginTTM.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#stat_profit_margin').append(netProfitMarginTTM_var);        
         $('#stat_profit_margin2').append(netProfitMarginTTM_var);                

         if (elem.ebitPerRevenueTTM == null) {var ebitPerRevenueTTM_var = 'n/a';} else
         {var ebitPerRevenueTTM_var = elem.ebitPerRevenueTTM.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#stat_ebit_margin').append(ebitPerRevenueTTM_var);                
        
        
      });
    })
});